import { CheckOutlined } from "@ant-design/icons";

const CheckSuccess: React.FC = ()=>(
    <CheckOutlined
    style={{
        backgroundColor: '#D0E1F4',
        color: '#3587E8',
        fontSize: '25px',
        padding: '10px',
        borderRadius: '10px',
        border: '0.5px solid #3587E8'
    }}
    />
)
export default CheckSuccess;